<script setup lang="ts">
import BackIcon from '@/assets/svg/icons/back.svg?url';

const props = defineProps<{
  transparent?: boolean;
  title?: string;
  backIcon?: string;
  onBack?: () => void;
}>();
</script>

<template>
  <ion-header class="app-header" :class="{ transparent: props.transparent }" v-bind="$attrs">
    <ion-toolbar :color="transparent ? undefined : 'dark'" class="px-4">
      <div class="flex items-center gap-2 min-h-[54px]">
        <ion-icon
          v-if="onBack || backIcon"
          :icon="backIcon || BackIcon"
          class="size-7 min-w-7 min-h-7 z-10"
          @click="onBack"
        />
        <h4 v-if="title" class="px-2 text-left font-bold">{{ title }}</h4>
        <slot name="title" />
      </div>
      <slot />
    </ion-toolbar>
  </ion-header>
</template>

<style lang="scss">
.app-header {
  background: var(--ion-color-dark);
  &.transparent {
    background: transparent !important;
    --background: transparent !important;
    --border-width: 0 !important;
    --border-color: transparent !important;

    &::after,
    &::before {
      display: none !important;
    }

    ion-toolbar {
      --background: transparent !important;
      background: transparent !important;
      --border-width: 0 !important;
      --border-color: transparent !important;

      &::after,
      &::before {
        display: none !important;
      }
    }
  }
  ion-title {
    font-family: 'DM Sans-Bold';
  }
  ion-toolbar {
    height: 100%;
    --padding-top: 0;
    --padding-bottom: 0;
  }
}
</style>
